import { SET_PAYMENTVIEWLIST } from '../actions';

const paymenthistoryview = (state = [], action) => {
  switch (action.type) {
	case SET_PAYMENTVIEWLIST:
      return [...action.value];  
    default: return state;
  }
}

export default paymenthistoryview;
